var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcApprove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.473,
    height: 14.521,
    viewBox: "0 0 20.473 14.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-approve",
    transform: "translate(-2.15 -9.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2373",
    "data-name": "Path 2373",
    d: "M9.394,23.347,2.342,16.252a.671.671,0,0,1,0-.94l.94-.94a.671.671,0,0,1,.94,0l5.3,5.343a.465.465,0,0,0,.641,0L20.55,9.242a.671.671,0,0,1,.94,0l.94.94a.671.671,0,0,1,0,.94l-12.1,12.224A.6.6,0,0,1,9.394,23.347Z",
    fill: "#14bb02"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcApprove);
export default __webpack_public_path__ + "static/media/ic-approve.dcb2ecd2.svg";
export { ForwardRef as ReactComponent };